import React, { Component , Fragment} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const styles = theme => ({
  paper: {
    position: 'absolute',
    width: theme.spacing(50),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(8),
    color:'navy',
    fontWeight : "bold",
 },
 title: {
  marginTop: -theme.spacing(2),
  marginBottom: theme.spacing(3),
  textAlign: 'center',
  backgroundColor : '#f0f0f0'
},
message: {
  margin: theme.spacing(2),
  textAlign: 'left',
},
});

class ShowDialog extends Component {
 constructor(props) {
  super(props);
  this.state = {
     open: this.props.open,
   };
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.props.message}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
          {!this.props.statement &&
            <>  
              <Button onClick={() => this.props.onAnswer(true, this.props.func)} color="primary" autoFocus>
                Да
            </Button>
              <Button onClick={() => this.props.onAnswer(false, this.props.func)} color="primary">
                Нет
            </Button>
            </>
          }
          {this.props.statement &&
            <Button onClick={() => this.props.onAnswer(false, this.props.func)} color="primary">
                Хорошо
            </Button>
          }
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

ShowDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ShowDialog);